import getProvider from "./rpcProviderService";

const getWallet = async (onChange) => {
    let provider;
    let signer;
    let isReadOnly = true;
    let isWrongNetwork = false;
    if (window.ethereum) {
        try {
            provider = getProvider(false);
            await provider.send("eth_requestAccounts", []);
            signer = provider.getSigner();
            isReadOnly = false;
            // if(onChange) 
            //     window.ethereum.on('accountsChanged', onChange);
        } catch (error) {
            console.log("JsonRPC");
            provider = getProvider(true);
        }
    } else {
        console.log("JsonRPC");
        provider = getProvider(true);
    }
    // isWrongNetwork = (await provider.getNetwork()).name == 'matic' ? false : true;
    // const maxFeePerGas = (await getGasPrice()).toFixed(2);
    isWrongNetwork = false;
    const maxFeePerGas = {}
    return { provider, signer, isReadOnly, isWrongNetwork, maxFeePerGas };
}

export const disconnectWallet = async () => {
    window.ethereum.request({
        method: "wallet_revokePermissions",
        params: [{ eth_accounts: {} }],
    });
}


export default getWallet;